import { ResponsiveImage } from '../components/ResponsiveImage'
import { images } from '../data/images'

const topProducts = [
  { rank: '01', name: 'OI Shampoo', price: '$43' },
  { rank: '02', name: 'OI Hair Butter', price: '$52' },
  { rank: '03', name: 'OI All In One Milk', price: '$46' },
  { rank: '04', name: 'K18 Molecular Mask', price: '$75' },
  { rank: '05', name: 'K18 AirWash', price: '$48' },
  { rank: '06', name: 'SESSION.SPRAY FLEX', price: '$39' },
  { rank: '07', name: 'BEDROOM.HAIR', price: '$39' },
  { rank: '08', name: 'DOO.OVER', price: '$39' },
  { rank: '09', name: 'BODY.BUILDER', price: '$39' },
  { rank: '10', name: 'FRESH.HAIR', price: '$36' },
]

const photographedFavorites = [
  {
    number: '07',
    name: 'BEDROOM.HAIR',
    note: 'Flexible texture with an undone, touchable finish.',
    image: images['kevin-murphy-bedroom-hair-texturizing-hairspray'],
    alt: 'Kevin Murphy Bedroom.Hair texturizing hairspray',
  },
  {
    number: '08',
    name: 'DOO.OVER',
    note: 'Dry powder finishing spray for airy volume and hold.',
    image: images['kevin-murphy-doo-over-dry-powder-finishing-spray'],
    alt: 'Kevin Murphy Doo.Over dry powder finishing spray',
  },
  {
    number: '10',
    name: 'FRESH.HAIR',
    note: 'A between-wash refresh paired here with Hair.Resort.',
    image: images['kevin-murphy-fresh-hair-hair-resort'],
    alt: 'Kevin Murphy Fresh.Hair dry shampoo and Hair.Resort texturizer',
  },
]

const editorialProducts = [
  {
    image: images['kevin-murphy-blow-dry-hair-care-collection'],
    alt: 'Kevin Murphy Blow.Dry professional hair care collection',
    brand: 'Kevin Murphy',
    title: 'Blow.Dry collection',
    detail: 'Smoothness, bounce, and heat-activated style support.',
    layout: 'wide',
  },
  {
    image: images['k18-professional-molecular-repair-hair-mist'],
    alt: 'K18 Professional Molecular Repair Hair Mist',
    brand: 'K18',
    title: 'Molecular Repair Hair Mist',
    detail: 'Professional preparation for resilient-looking hair.',
    layout: 'portrait',
  },
  {
    image: images['brazilian-blowout-anti-frizz-hair-care-system'],
    alt: 'Brazilian Blowout anti-frizz shampoo conditioner and bonding spray',
    brand: 'Brazilian Blowout',
    title: 'Anti-frizz care system',
    detail: 'A coordinated wash, condition, and bonding ritual.',
    layout: 'standard',
  },
  {
    image: images['kevin-murphy-hydrate-me-masque'],
    alt: 'Kevin Murphy Hydrate-Me Masque hair treatment',
    brand: 'Kevin Murphy',
    title: 'Hydrate-Me.Masque',
    detail: 'A smoothing masque for a polished, replenished finish.',
    layout: 'tall',
  },
  {
    image: images['kevin-murphy-body-mass-leave-in-treatment'],
    alt: 'Kevin Murphy Body.Mass leave-in treatment',
    brand: 'Kevin Murphy',
    title: 'Body.Mass',
    detail: 'Leave-in fullness and conditioning support.',
    layout: 'standard',
  },
  {
    image: images['kevin-murphy-pink-hair-care-collection'],
    alt: 'Pink Kevin Murphy hair care collection',
    brand: 'Kevin Murphy',
    title: 'The volume edit',
    detail: 'A tonal collection of wash, rinse, styling, and finishing care.',
    layout: 'wide',
  },
  {
    image: images['kevin-murphy-plumping-wash-rinse'],
    alt: 'Kevin Murphy Plumping.Wash and Plumping.Rinse hair care duo',
    brand: 'Kevin Murphy',
    title: 'Plumping.Wash + Rinse',
    detail: 'A wash-day pairing designed around body and fullness.',
    layout: 'portrait',
  },
  {
    image: images['jvn-nurture-hydrating-shampoo-conditioner'],
    alt: 'JVN Nurture hydrating shampoo and conditioner',
    brand: 'JVN',
    title: 'Nurture hydration duo',
    detail: 'Hydrating shampoo and conditioner in a vivid blue pairing.',
    layout: 'wide',
  },
  {
    image: images['ehp-rush-and-brush-keratin-dry-shampoo'],
    alt: 'EHP Rush & Brush keratin infused dry shampoo',
    brand: 'EHP',
    title: 'Rush & Brush',
    detail: 'Keratin-infused dry shampoo for a quick refresh.',
    layout: 'portrait',
  },
  {
    image: images['kevin-murphy-maxi-wash-detox-shampoo'],
    alt: 'Kevin Murphy Maxi.Wash detox shampoo',
    brand: 'Kevin Murphy',
    title: 'Maxi.Wash',
    detail: 'A focused detox shampoo for a clean foundation.',
    layout: 'tall',
  },
  {
    image: images['kevin-murphy-staying-alive-leave-in-treatment'],
    alt: 'Kevin Murphy Staying.Alive leave-in treatment',
    brand: 'Kevin Murphy',
    title: 'Staying.Alive',
    detail: 'Lightweight leave-in care for everyday conditioning.',
    layout: 'standard',
  },
  {
    image: images['kevin-murphy-angel-hair-care-collection'],
    alt: 'Kevin Murphy Angel.Wash Angel.Rinse and Untangled hair care collection',
    brand: 'Kevin Murphy',
    title: 'Angel care collection',
    detail: 'Wash, rinse, and detangling care for a weightless routine.',
    layout: 'wide',
  },
  {
    image: images['kevin-murphy-young-again-treatment-oil'],
    alt: 'Kevin Murphy Young.Again treatment oil',
    brand: 'Kevin Murphy',
    title: 'Young.Again',
    detail: 'An immortelle-infused treatment oil with a refined finish.',
    layout: 'portrait',
  },
  {
    image: images['kevin-murphy-blow-dry-wash-ever-bounce'],
    alt: 'Kevin Murphy Blow.Dry Wash Rinse and Ever.Bounce collection',
    brand: 'Kevin Murphy',
    title: 'Blow.Dry Wash + Ever.Bounce',
    detail: 'Nourishing wash care paired with lasting bounce.',
    layout: 'wide',
  },
  {
    image: images['kevin-murphy-bedroom-hair-texturizing-products'],
    alt: 'Kevin Murphy Bedroom.Hair texturizing products',
    brand: 'Kevin Murphy',
    title: 'Bedroom.Hair duo',
    detail: 'Flexible texture and an intentionally lived-in finish.',
    layout: 'standard',
  },
  {
    image: images['kevin-murphy-smooth-again-anti-frizz-treatment'],
    alt: 'Kevin Murphy Smooth.Again anti-frizz treatment',
    brand: 'Kevin Murphy',
    title: 'Smooth.Again',
    detail: 'Anti-frizz treatment for smoothness and control.',
    layout: 'portrait',
  },
]

export function Products() {
  return (
    <>
      <section className="products-hero" aria-labelledby="products-title">
        <div className="products-hero__image reveal reveal--image">
          <ResponsiveImage
            image={images['diamond-salon-professional-hair-products-display']}
            alt="Professional hair products available at Diamond Salon"
            sizes="(max-width: 760px) 100vw, 50vw"
            priority
          />
        </div>
        <div className="products-hero__content shell reveal reveal--heading">
          <span className="eyebrow">The retail edit</span>
          <h1 id="products-title">Products</h1>
          <p>Professional formulas, considered essentials, and the products our artists reach for behind the chair.</p>
        </div>
      </section>

      <section className="products-ranking section" aria-labelledby="top-products-title">
        <header className="products-ranking__intro shell reveal reveal--heading">
          <span className="eyebrow">Diamond favorites / 01—10</span>
          <h2 id="top-products-title">Top 10 Salon Products</h2>
          <p>A concise edit of the treatments, stylers, and daily essentials most requested in the salon.</p>
        </header>
        <ol className="products-ranking__list shell">
          {topProducts.map((product, index) => (
            <li className={`product-rank reveal reveal--delay-${index % 3}`} key={product.rank}>
              <span className="product-rank__number" aria-hidden="true">{product.rank}</span>
              <h3>{product.name}</h3>
              <span className="product-rank__price">{product.price}</span>
            </li>
          ))}
        </ol>
      </section>

      <section className="products-favorites section" aria-labelledby="photographed-favorites-title">
        <header className="products-favorites__header shell reveal reveal--heading">
          <span className="eyebrow eyebrow--light">From the Top 10</span>
          <h2 id="photographed-favorites-title">Three favorites,<br /><em>in the frame.</em></h2>
          <p>Three shelf essentials our artists return to for texture, volume, and a refreshed finish.</p>
        </header>
        <div className="products-favorites__grid shell">
          {photographedFavorites.map((product, index) => (
            <figure className={`favorite-product favorite-product--${index + 1} reveal reveal--image`} key={product.number}>
              <div className="favorite-product__image">
                <ResponsiveImage image={product.image} alt={product.alt} sizes="(max-width: 760px) 100vw, 42vw" />
              </div>
              <figcaption>
                <span>{product.number} / Top 10</span>
                <h3>{product.name}</h3>
                <p>{product.note}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section className="product-lookbook section" aria-labelledby="product-lookbook-title">
        <header className="product-lookbook__header shell reveal reveal--heading">
          <span className="eyebrow">The product edit / 2026</span>
          <h2 id="product-lookbook-title">Care, finish,<br /><em>and ritual.</em></h2>
          <p>A curated look at the professional formulas available on our shelves, selected to carry the salon experience home.</p>
        </header>
        <div className="product-lookbook__grid shell">
          {editorialProducts.map((product, index) => (
            <figure className={`product-editorial product-editorial--${product.layout} reveal reveal--image reveal--delay-${index % 3}`} key={product.title}>
              <div className="product-editorial__image">
                <ResponsiveImage image={product.image} alt={product.alt} sizes="(max-width: 700px) 100vw, 50vw" />
              </div>
              <figcaption>
                <span>{product.brand}</span>
                <h3>{product.title}</h3>
                <p>{product.detail}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </>
  )
}
